$(function() {
  if (typeof window.googAnalyticsID !== "undefined") {
    gtag('set', window.googTrackingData);

    var googConfig = {
      allow_enhanced_conversions: true,
      page_path: window.location.pathname,
    };

    gtag('config', window.googAnalyticsID, googConfig);
  };
});
